// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { MemberState } from "@/types/member";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Member } from "@/models/member";

const state: MemberState = {
  single: new Member(),
  pagination: new Pagination(),
};

export const member: Module<MemberState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
